module.exports = __webpack_public_path__ + "981d922df62e70e57f864b265778d7f0.svg";